import { render, staticRenderFns } from "./BaseForm1.vue?vue&type=template&id=09562b5e&scoped=true&"
import script from "./BaseForm1.vue?vue&type=script&lang=js&"
export * from "./BaseForm1.vue?vue&type=script&lang=js&"
import style0 from "./BaseForm1.vue?vue&type=style&index=0&id=09562b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09562b5e",
  null
  
)

export default component.exports